import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard')({
  beforeLoad: () => {
    throw redirect({
      to: '/n/dashboard',
      replace: true,
    });
  },
});
